// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumb_container__ymJ6l","item":"Breadcrumb_item__9i5TZ","delimiter":"Breadcrumb_delimiter__HO3Cn"};